<div
  class="textarea-container"
  [attr.data-size]="size"
  [attr.data-disabled]="disabled"
  [attr.data-error]="error"
  [attr.data-has-value]="hasValue"
>
  <label *ngIf="label" class="textarea-label" [for]="inputId">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>

  <div class="textarea-wrapper">
    <textarea
      #textarea
      [id]="inputId"
      class="textarea-input"
      [style.resize]="resize"
      [placeholder]="placeholder"
      [rows]="rows"
      [disabled]="disabled"
      [readonly]="readonly"
      [required]="required"
      [value]="value"
      [attr.aria-label]="label"
      [attr.aria-required]="required"
      [attr.aria-invalid]="error"
      (input)="onTextareaInput($event)"
      (focus)="onTextareaFocus()"
      (blur)="onTextareaBlur()"
    >
    </textarea>

    <div *ngIf="maxLength" class="character-count">
      {{ characterCount }}
    </div>
  </div>

  <p *ngIf="helperText && !error" class="helper-text">
    {{ helperText }}
  </p>

  <p *ngIf="error && errorMessage" class="error-message">
    {{ errorMessage }}
  </p>
</div>
